import TUCardDescription from './TUCardDescription';

export default TUCardDescription;
